import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

interface MovieCardProps {
  movie: Movie;
  index?: number;
}

export default function MovieCard({ movie, index = 0 }: MovieCardProps) {
  return (
    <Link
      to={`/movie/${movie.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200/80 bg-background-100 transition-all duration-300 hover:border-primary-500/60 hover:-translate-y-1"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 电影海报 - 午夜场的电影`}
          title={`${movie.title} - 午夜电影推荐`}
          className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/10 to-transparent" />
        <span className="absolute top-3 left-3 flex items-center gap-1 rounded-full bg-background-50/85 px-2.5 py-1 text-xs font-semibold text-primary-400 backdrop-blur">
          <i className="ri-star-fill text-primary-500"></i>
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute bottom-3 right-3 rounded-md bg-background-50/85 px-2 py-0.5 text-[11px] text-foreground-300 backdrop-blur">
          {movie.year}
        </span>
      </div>
      <div className="p-4">
        <h3 className="mb-1 truncate font-heading text-[15px] font-bold text-foreground-50 transition-colors group-hover:text-primary-400">
          {movie.title}
        </h3>
        <p className="mb-3 line-clamp-2 text-xs leading-relaxed text-foreground-600">
          {movie.summary}
        </p>
        <div className="flex flex-wrap gap-1.5">
          {movie.genres.slice(0, 3).map((genre) => (
            <span
              key={genre}
              className="rounded-full bg-secondary-900/60 px-2 py-0.5 text-[11px] text-secondary-200"
            >
              {genre}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}